import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { fetchLiquidacionesListaSellers } from '../../../actions/sellersActions';
import { fetchEstadosLiquidaciones } from '../../../actions/LiquidacionesActions';
import { fetchLiquidacionesBusqueda } from '../../../actions/LiquidacionesActions';
import { limpiarLiquidacionesBusqueda } from '../../../actions/LiquidacionesActions';
import { getLiquidacionesListaSellers } from '../../../api/axios.js';
import { getEstadosLiquidacionesCorrecto } from '../../../api/axios.js';
import { customStyle, DropDownArrow } from "../../../template/CustomStyle";
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { getLiquidacionesBusqueda } from '../../../api/axios.js';
import { exportToExcel } from '../../../components/General/Excel/ExcelExportHelper';

class ExportarLiquidaciones extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            request: null,
            datosExcelFormateados: null,
            estadoCheckbox: false,
            hideSpinner: true,
            lista_sellers_liquidaciones: [],
            lista_estados_liquidaciones: [],
            lista_liquidaciones_busqueda: [],
            comboLiquidacionSeller: { label: "", value: "" },
            comboLiquidacionEstado: { label: "", value: "" },
            fechaDesde: "",
            fechaDesdePredeterminado: "",
            fechaHasta: "",
            fechaHastaPredeterminado: "",
            elements: ""
        }
    };

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
        });
    }
    
    busquedaParaDescargarExcel = () => {

        if (this.state.estadoCheckbox === true) {
        
            this.setState({hideSpinner: false});

            this.props.fetchLiquidacionesBusqueda();

            const listaOrdenesExcel = [];

            localStorage.setItem("GestionDeLiquidacionFechaDesde", document.getElementById("GestionDeLiquidacionFechaDesde").value);
            localStorage.setItem("GestionDeLiquidacionFechaHasta", document.getElementById("GestionDeLiquidacionFechaHasta").value);
            localStorage.setItem("GestionDeLiquidacionSeller", 0);
            localStorage.setItem("GestionDeLiquidacionEstado", 0);
            localStorage.setItem("GestionDeLiquidacionBuscaTodo", 1);

            getLiquidacionesBusqueda().then(res => {

                var objeto = res['encabezado'];

                for (var j in objeto) {
                    let cargaNovedadesExcel = {
                        seller: objeto[j]['razonSocialSeller'],
                        fecha: objeto[j]['mostrarFecha'],
                        estado: objeto[j]['tipoEstadoLiquidacionMostrar'],
                        idLiquidacion: objeto[j]['idLiquidacion'],
                        cantNovedades: objeto[j]['cantidadNovedades'],
                        cantOrdenes: objeto[j]['cantidadOrdenes'],
                        comisionNeta: objeto[j]['comisionNeta'],
                        comisionTotal: objeto[j]['comisionTotal'],
                        totalLiquidacion: objeto[j]['totalLiquidacion'],
                        TotalNovedades: objeto[j]['totalNovedades'],
                        totalOrdenes: objeto[j]['totalOrden'],
                    }
                    listaOrdenesExcel.push(cargaNovedadesExcel);
                }
            
                this.setState({
                    datosExcelFormateados: listaOrdenesExcel,
                    hideSpinner: true
                });

                var link = null;
                link = document.getElementById('btnDescargaExcel');
                link.click();
            });
        }
    }

    componentWillMount() {
        localStorage.setItem("GestionDeLiquidacionFechaDesde", "01-01-1900");
        localStorage.setItem("GestionDeLiquidacionFechaHasta", "01-01-1900");
    }

    componentDidMount() {
        localStorage.removeItem("GestionDeLiquidacionFechaDesde");
        localStorage.removeItem("GestionDeLiquidacionFechaHasta");
        localStorage.removeItem("GestionDeLiquidacionSeller");
        localStorage.removeItem("GestionDeLiquidacionEstado");

        this.props.limpiarLiquidacionesBusqueda();
        this.setState({ lista_liquidaciones_busqueda: [] });

        localStorage.setItem('GestionDeLiquidacionEstado', 2);

        let fecha = new Date();
        fecha.setDate(fecha.getDate() - 15);
        let fechaNewQuince = fecha.toISOString().slice(0, 10);

        let fechasesenta = new Date();
        fechasesenta.setDate(fechasesenta.getDate() - 60);
        let fechafechasesentafinal = fechasesenta.toISOString().slice(0, 10);

        let fechaActual = new Date();
        fechaActual.setDate(fechaActual.getDate());
        let fechaNewActual = fechaActual.toISOString().slice(0, 10);
        this.setState({
            fechaDesdesesenta: fechafechasesentafinal,
            fechaDesde: fechaNewQuince,
            fechaDesdePredeterminado: fechaNewQuince,
            fechaHasta: fechaNewActual,
            fechaHastaPredeterminado: fechaNewActual,
        });
    }

    selectSearchHandlerLiquidacionesSeller = (options) => {

        let valor = { label: options.label, value: options.value.toString() };
        this.setState({
            comboLiquidacionSeller: valor
        })
        localStorage.setItem('GestionDeLiquidacionSeller', options.value);
    }

    selectSearchHandlerLiquidacionesEstado = (options) => {

        let valor = { label: options.label, value: options.value.toString() };
        this.setState({
            comboLiquidacionEstado: valor
        })
        localStorage.setItem('GestionDeLiquidacionEstado', options.value);
    }

    mapSellers = () => {
        getLiquidacionesListaSellers().then(res => {
            let listaTipo = res.listaSellersLiquidaciones.map((tipo) => {
                return { label: tipo.razonSocial, value: tipo.codigo.toString() };
            })
            this.setState({
                lista_sellers_liquidaciones: listaTipo
            })
        })
    }

    mapEstados = () => {
        getEstadosLiquidacionesCorrecto().then(res_estados => {
            let listaEstado = res_estados.listadoEstadosLiquidaciones.map((tipo, index) => {
                return { label: tipo.descripcion, value: tipo.idEstado.toString() };
            })
            this.setState({
                lista_estados_liquidaciones: listaEstado
            })
        });
    }
    
    render() {
        
        let selectListaSellers = <div style={{
            position: "relative",
            left: "-15px",
            paddingBottom: "10px"
        }} className="col-lg-12">
            <p className="font-bold">
                Seller
            </p>
            <Select
                name="GestionDeLiquidacionSeller"
                id="GestionDeLiquidacionSeller"
                value={this.state.comboLiquidacionSeller}
                options={this.state.lista_sellers_liquidaciones}
                onChange={this.selectSearchHandlerLiquidacionesSeller}
                onClick={this.cargarseller}
                onInputChange={this.cargarseller}
                onMenuOpen={this.mapSellers}
                styles={customStyle}
                components={{ DropdownIndicator: () => DropDownArrow }}
            />
        </div>

        let selectListaEstados = <div style={{
            position: "relative",
            left: "-15px",
            paddingBottom: "10px"
        }} className="col-lg-12">
            <p className="font-bold">
                Estados
            </p>
            <Select
                name="GestionDeLiquidacionEstado"
                id="GestionDeLiquidacionEstado"
                defaultValue={{ label: "En Preparacion", value: "2" }}
                options={this.state.lista_estados_liquidaciones}
                onChange={this.selectSearchHandlerLiquidacionesEstado}
                onMenuOpen={this.mapEstados}
                styles={customStyle}
                components={{ DropdownIndicator: () => DropDownArrow }}
            />
        </div>

        let sizeArray = JSON.stringify(this.state.datosExcelFormateados);


        return (
        <div className="row justify-content-between page-titles">

            <div className="col-md-8">
                <h4 className="text-themecolor color-rojo-megatone mx-1">Liquidaciones</h4>
            </div>

            <div className="col-md-2 button-group align-self-center text-right d-none d-md-block">
                <Spinner hidden={this.state.hideSpinner || sizeArray == "[]"} style={{ position: "relative", top: "5px", right: "0px", padding: "0px", margin: "0px" }} animation="border" variant="secondary" size="sm-centrado" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </div>

            <div className="col-2 button-group text-end">
                    
                <button 
                    type="button" 
                    onClick={this.busquedaParaDescargarExcel} 
                    className="btn btn-sm btn-green" 
                    disabled={!this.state.estadoCheckbox}
                >
                    Descargar Excel
                </button>

                <button 
                    id="btnDescargaExcel" 
                    className="d-none" 
                    onClick={() => exportToExcel(
                        this.state.datosExcelFormateados, 
                        'liquidaciones', 
                        'Liquidaciones'
                    )}
                ></button>
            </div>

            <div className="card card-body filter-card m-3">
                <div className="row form-material">
                    
                    <div className="col-md-2">
                        <p className="font-bold">Desde</p>
                        <input type="date" name="GestionDeLiquidacionFechaDesde" id="GestionDeLiquidacionFechaDesde" min={this.state.fechaDesdesesenta} className="form-control" defaultValue={this.state.fechaDesde} />
                    </div>

                    <div className="col-md-2">
                        <p className="font-bold">Hasta</p>
                        <input type="date" name="GestionDeLiquidacionFechaHasta" id="GestionDeLiquidacionFechaHasta" className="form-control" defaultValue={this.state.fechaHasta}/>
                    </div>
                
                    <div className="col-3">
                        {selectListaSellers}
                    </div> 

                    <div className="col-3">
                        {selectListaEstados}
                    </div>
                </div>

                <div className="ibox-content float-e-margins">
                    <input 
                        id="BuscaTodo" 
                        type="checkbox" 
                        onChange={(e) => this.setState({estadoCheckbox: e.target.checked})} 
                    /> 
                    <label for="BuscaTodo">
                        Todas las liquidaciones de todos los sellers en el rango de tiempo
                    </label>
                </div>
            </div>
        </div>
        );
    }
}


const mapStateToProps = state => ({
    lista_sellers_liquidaciones: state.sellers.lista_sellers_liquidaciones,
    tipoUsuario: state.general.tipoUsuario,
    lista_estados_liquidaciones: state.liquidaciones.lista_estados_liquidaciones,
    lista_liquidaciones_busqueda: state.liquidaciones.lista_liquidaciones_busqueda
});

const mapDispatchToProps = dispatch => ({
    fetchLiquidacionesListaSellers: bindActionCreators(fetchLiquidacionesListaSellers, dispatch),
    fetchEstadosLiquidaciones: bindActionCreators(fetchEstadosLiquidaciones, dispatch),
    fetchLiquidacionesBusqueda: bindActionCreators(fetchLiquidacionesBusqueda, dispatch),
    limpiarLiquidacionesBusqueda: bindActionCreators(limpiarLiquidacionesBusqueda, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ExportarLiquidaciones);